import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  buttonContainer: { alignItems: 'center', flexDirection: 'row' },
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: -10,
    marginTop: scale(14),
    paddingHorizontal: scale(16),
  },
  editButton: {
    alignItems: 'center',
    backgroundColor: colors.secondary.softOrchid,
    borderRadius: scale(40),
    flexDirection: 'row',
    justifyContent: 'center',
    paddingHorizontal: scale(8),
    paddingVertical: scale(4),
  },
  editText: {
    marginLeft: scale(4),
    marginTop: -2,
  },
});

export default styles;
